<template>
  <div>
    <div class="bg-white shadow rounded-lg divide-y divide-gray-200 overflow-hidden">
      <div class="px-4 py-3 sm:px-6 py-4 rounded-t-lg">
        {{ facebookPage.name }}
      </div>
      <div class="flex">
        <div class="w-64 space-y-2 bg-gray-100 border-r border-gray-200">
          <ul class="divide-y divide-gray-200">
            <li
              v-for="metric in metrics"
              :key="metric.name"
              :class="[currentMetricName === metric.name ? 'bg-white -mr-px' : '']"
            >
              <label
                class="px-4 py-3 text-sm flex flex-1 space-x-2 items-center"
                v-tip="{ content: metric.description }"
              >
                <input
                  v-model="currentMetricName"
                  type="radio"
                  :value="metric.name"
                  class="hidden"
                />
                <span class="flex-1 truncate">
                  {{ metric.title }}
                </span>
              </label>
            </li>
          </ul>
        </div>
        <div class="flex-1">
          <div v-if="currentMetric" class="divide-y divide-gray-200">
            <Metric
              :metric="currentMetric"
              :account-id="accountId"
              :facebook-page-id="facebookPageId"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { metrics } from '@/utils/instagram-insights-query-params';
import Metric from './metric.vue';

export default {
  components: {
    Metric,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    facebookPageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      metrics: [...metrics],
      currentMetricName: metrics?.[0]?.name || null,
    };
  },
  computed: {
    facebookPage() {
      return this.$store.state.entities.facebookPages.byId[this.facebookPageId];
    },
    currentMetric() {
      return this.currentMetricName
        ? metrics.find((metric) => metric.name === this.currentMetricName) || null
        : null;
    },
  },
  methods: {
    //
  },
};
</script>
